<div class="flex gap-2 pb-2">
  <span class="flex-grow-1 input-field p-input-icon-right">
      <input pInputText placeholder="Búsqueda rápida..." [(ngModel)]="searchParams.name" (keydown.enter)="search()"
          class="w-full" />
      <i *ngIf="searchParams.name" class="pi pi-times cursor-pointer"
          (click)="searchParams.name = null; search()"></i>
  </span>
  <div class="input-field">
        <div class="flex gap-1">    
            <div class="flex-grow-1">
                <p-calendar [firstDayOfWeek]="1" [(ngModel)]="date" [showIcon]="true" [showTime]="false" [hourFormat]="'24'" dateFormat="dd/mm/yy"
                    d-form-field-error appendTo="body" (onSelect)="search()"></p-calendar>
            </div>
            <p-button (click)="prevDate()" ><i class="pi pi-chevron-left"></i></p-button>
            <p-button (click)="nextDate()"><i class="pi pi-chevron-right"></i></p-button>
        </div>
    </div>
  <div class="input-field" style="width: 150px">
    <label class="inline-flex align-items-center gap-2 cursor-pointer"><p-checkbox [(ngModel)]="searchParams.dateEnd" name="dateEnd"
                     (onChange)="search()" [binary]="true" />Ver citas terminadas</label>
  </div>
  <div class="input-field" style="width: 150px;">
        <p-dropdown placeholder="Tramitador" [options]="processors" optionLabel="name" optionValue="id"
            [filter]="true" [filterBy]="'name'"
            [(ngModel)]="searchParams.processorId" (onChange)="search()" showClear />
    </div>
  <div class="input-field" style="width: 150px;">
      <p-dropdown placeholder="Operario" [options]="workers" optionLabel="name" optionValue="id"
          [(ngModel)]="searchParams.workerId" (onChange)="search()" showClear [filter]="true" />
  </div>
  <div class="input-field" style="width: 150px;">
      <p-dropdown placeholder="Estado" [options]="states" optionLabel="name" optionValue="id"
          [(ngModel)]="searchParams.stateId" (onChange)="search()" showClear [filter]="true" />
  </div>
</div>
<div class="grid">
  <p-card class="col-12  p-card-header-pb-0 p-card-content-pt-0">
    <ng-template pTemplate="header">
            <div class="flex align-items-center justify-content-between">
                <div class="p-card-title">Citas a tramitar</div>
                <div class="flex-grow-1"></div>
                <p-button *ngIf="allowAssignProcessor" (click)="assignProcessor()" icon="pi pi-user" label="Asignar tramitador" ></p-button>
            </div>
        </ng-template>
    <div class="flex justify-content-end gap-2">
        <p-badge severity="info" [value]="'En tiempo (' + totals.OnTime + ')'" pTooltip="Hora prevista + 20 minutos de margen" tooltipPosition="bottom" />
        <p-badge severity="danger" [value]="'Llega tarde (' + totals.TooLate + ')'" pTooltip="Hora prevista + 20 minutos de margen" />
        <p-badge severity="warn" [value]="'Iniciada (' + totals.Started + ')'" />
        <p-badge severity="success" [value]="'Finalizada (' + totals.Ended + ')'" />
        <p-badge severity="danger" [value]="'Rechazada (' + totals.Rejected + ')'" />
        <p-badge severity="warn" [value]="'Fallida (' + totals.Failed + ')'" />
        <p-badge styleClass="p-badge-contrast" [value]="'Total (' + totals.Total + ')'" />
    </div>
      <div class="mt-2">
          <p-table #grid [value]="caseServices" 
              [lazy]="true" (onLazyLoad)="loadServices($event)" 
              [loading]="loadingServices" [paginator]="false" [rows]="20"
              [totalRecords]="totalServicesRecords" [showCurrentPageReport]="true"
              currentPageReportTemplate="Mostrando de {first} a {last} de un total de {totalRecords} entradas"
              [rowsPerPageOptions]="[20,50,100]" [scrollable]="true" scrollHeight="flex"
              paginatorDropdownAppendTo="body" [(selection)]="selectedCases">
              <ng-template pTemplate="header" let-columns>
                  <tr>
                    <th *ngIf="allowAssignProcessor" style="width: 40px;">
                        <p-checkbox
                            [binary]="true"
                            [ngModel]="isAllCaseServicesSelected()"
                            (onChange)="toggleAllCaseServicesSelection($event.checked)">
                        </p-checkbox>
                    </th>
                    <th *ngIf="processors.length > 0">Tramitador</th>
                    <th  style="width: 130px;">Fecha Exped</th>
                    <th>Expediente</th>
                    <th>Operador</th>                      
                    <th width="120"></th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-service let-columns="columns">
                  <tr>
                    <td *ngIf="allowAssignProcessor">
                        <p-tableCheckbox [value]="service.caseId"></p-tableCheckbox>
                    </td>
                    <td *ngIf="processors.length > 0">
                        <div class="mt-2" [ngClass]="service.case?.processor?.absence ? 'text-danger' : ''">{{service.case?.processor?.name}} </div>
                    </td>
                    <td *ngIf="allowAssignProcessor">
                        {{service.case?.caseDate | date: 'dd/MM/yyyy HH:mm' }}
                    </td>
                    <td>
                        <a pTooltip="{{service.notes}}" [routerLink]="['/cases', service.case.id]">{{service.case?.caseNumber}} </a><br>
                        <app-case-service-materials [materials]="service.materials"></app-case-service-materials>
                        <div>{{service.case?.client?.name}}</div>
                        <div>{{service.case?.client.address?.fullAddress}}</div>
                        <a *ngIf="service.case?.client?.phone1!=null" (click)="showPhoneOverlayPanel($event, service.case.client?.phone1, service.case.client?.name, service.case?.id)">{{service.case?.client?.phone1}}</a> 
                        <span *ngIf="service.case?.client?.phone2!=null"> - </span> 
                        <a *ngIf="service.case?.client?.phone2!=null" (click)="showPhoneOverlayPanel($event, service.case.client?.phone2, service.case.client?.name, service.case?.id)">{{service.case?.client?.phone2}}</a>
                        
                    </td>
                    <td>
                        <div>
                        <b>{{service.date | date: 'HH:mm'}}</b>
                        </div>
                        <div *ngIf="service.dateStart!=null">
                        Visita iniciada a las {{service.dateStart | date: 'HH:mm'}}
                        </div>
                        <div *ngIf="service.dateEnd!=null">
                        Visita finalizada a las {{service.dateEnd | date: 'HH:mm'}}
                        </div>
                        <div>{{service.worker?.name}}</div>
                        <div>
                            <a *ngIf="service.worker?.phone1!=null"
                                (click)="showPhoneOverlayPanel($event, service.worker?.phone1, service.worker?.name, service.case?.id)">{{service.worker?.phone1}}</a>
                            <a *ngIf="service.worker?.phone2!=null"
                                (click)="showPhoneOverlayPanel($event, service.worker?.phone2, service.worker?.name, service.case?.id)">{{service.worker?.phone2}}</a>
                            <a *ngIf="service.worker?.mail!=null"
                                href="mailto:{{service.worker?.mail}}">{{service.worker?.mail}}</a>
                        </div>
                        <div>
                        <b *ngIf="isOnTime(service)"><p-badge [value]="'En tiempo'" severity="info" pTooltip="Hora prevista + 20 minutos de margen" tooltipPosition="bottom" /></b>
                        <b *ngIf="isTooLate(service)"><p-badge [value]="'Llega tarde'" severity="danger" pTooltip="Hora prevista + 20 minutos de margen" tooltipPosition="bottom" /></b>
                        <b *ngIf="isStarted(service)"><p-badge [value]="'Iniciada'" severity="warn" /></b>
                        <b *ngIf="isEnded(service)"><p-badge [value]="'Finalizada'" severity="success" /></b>
                        <b *ngIf="isFailed(service)"><p-badge [value]="'Fallida'" severity="warn" /></b>
                        <b *ngIf="isRejected(service)"><p-badge [value]="'Rechazada'" severity="danger" /></b>
                        </div>
                        <p-overlayPanel #phoneOverlayPanel>
                            <div class=" flex flex-column gap-2">
                            <a (click)="call(phoneOverlayPanelData.phoneNumber, phoneOverlayPanelData.callerId, phoneOverlayPanelData.caseId)">Llamar</a>
                            <a (click)="sms(phoneOverlayPanelData.phoneNumber,  phoneOverlayPanelData.caseId, phoneOverlayPanelData.caseServiceId)">Enviar sms</a>
                            <a (click)="whatsapp(phoneOverlayPanelData.phoneNumber, phoneOverlayPanelData.caseId, phoneOverlayPanelData.callerId)">Enviar whatsapp</a>
                            </div>
                        </p-overlayPanel>
                    </td>
                    <td>
                        <div class="flex gap-2 justify-content-end">
                            <p-button (click)="openChat(service)" [rounded]="true" [text]="false">
                                <i class="pi pi-comments"></i>
                            </p-button>
                        </div>
                    </td>
                  </tr>
              </ng-template>
              <ng-template pTemplate="emptymessage" let-columns>
                  <tr>
                      <td [attr.colspan]="7">
                          No se han encontrado servicios a tramitar hoy
                      </td>
                  </tr>
              </ng-template>
          </p-table>
      </div>
  </p-card>
</div>

<p-dialog header="Seleccione un tramitador" [(visible)]="displayProcessorModal" [modal]="true" [closable]="false"
    [style]="{width: '400px'}">
    <p-messages severity="info">
        <ng-template pTemplate>
            Se van a cambiar el tramitador a {{selectedCaseIds.length}} expediente{{selectedCaseIds.length>1?'s':''}}.
        </ng-template>
    </p-messages>
        
    <div class="input-field">
        <label for="date">Tramitador</label>
        <p-dropdown [options]="processors" [(ngModel)]="processorId" optionLabel="name" optionValue="id" 
            appendTo="body" [filter]="true" showClear ></p-dropdown>
    </div>

    <ng-template pTemplate="footer">
        <button pButton label="Cancelar" icon="pi pi-times" class="p-button-secondary"
            (click)="displayProcessorModal=false;"></button>
        <button pButton label="Asignar" icon="pi pi-check" (click)="saveProcessor()"></button>
    </ng-template>
</p-dialog>